/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createAcceptedCreditRequest } from '../fn/credit-request/create-accepted-credit-request';
import { CreateAcceptedCreditRequest$Params } from '../fn/credit-request/create-accepted-credit-request';
import { CreditRequestDto } from '../models/credit-request-dto';
import { findCreditRequests } from '../fn/credit-request/find-credit-requests';
import { FindCreditRequests$Params } from '../fn/credit-request/find-credit-requests';
import { FindCreditRequestsResponseDto } from '../models/find-credit-requests-response-dto';
import { patchCreditRequest } from '../fn/credit-request/patch-credit-request';
import { PatchCreditRequest$Params } from '../fn/credit-request/patch-credit-request';

@Injectable({ providedIn: 'root' })
export class GeneratedCreditRequestService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findCreditRequests()` */
  static readonly FindCreditRequestsPath = '/api/credit-requests';

  /**
   * Finds open credit requests.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findCreditRequests()` instead.
   *
   * This method doesn't expect any request body.
   */
  findCreditRequests$Response(params: FindCreditRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<FindCreditRequestsResponseDto>> {
    return findCreditRequests(this.http, this.rootUrl, params, context);
  }

  /**
   * Finds open credit requests.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findCreditRequests$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findCreditRequests(params: FindCreditRequests$Params, context?: HttpContext): Observable<FindCreditRequestsResponseDto> {
    return this.findCreditRequests$Response(params, context).pipe(
      map((r: StrictHttpResponse<FindCreditRequestsResponseDto>): FindCreditRequestsResponseDto => r.body)
    );
  }

  /** Path part for operation `createAcceptedCreditRequest()` */
  static readonly CreateAcceptedCreditRequestPath = '/api/credit-requests';

  /**
   * Creates an immediately "accepted" credit request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAcceptedCreditRequest()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createAcceptedCreditRequest$Response(params: CreateAcceptedCreditRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<CreditRequestDto>> {
    return createAcceptedCreditRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates an immediately "accepted" credit request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAcceptedCreditRequest$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createAcceptedCreditRequest(params: CreateAcceptedCreditRequest$Params, context?: HttpContext): Observable<CreditRequestDto> {
    return this.createAcceptedCreditRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreditRequestDto>): CreditRequestDto => r.body)
    );
  }

  /** Path part for operation `patchCreditRequest()` */
  static readonly PatchCreditRequestPath = '/api/credit-requests/{id}';

  /**
   * Patches an open credit request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchCreditRequest()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchCreditRequest$Response(params: PatchCreditRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<CreditRequestDto>> {
    return patchCreditRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Patches an open credit request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchCreditRequest$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchCreditRequest(params: PatchCreditRequest$Params, context?: HttpContext): Observable<CreditRequestDto> {
    return this.patchCreditRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreditRequestDto>): CreditRequestDto => r.body)
    );
  }

}
